import { render, staticRenderFns } from "./ScriptRequests.vue?vue&type=template&id=caf7edc4"
import script from "./ScriptRequests.vue?vue&type=script&lang=js"
export * from "./ScriptRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports